import React from "react";

const GreenTickSVG = () => {
  return (
    <svg width="26" height="20" viewBox="0 0 26 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.34548 8.65157C1.80612 8.19093 2.55297 8.19093 3.01361 8.65157L10.0432 15.6811L22.9864 1.81666C23.447 1.35602 24.1939 1.35602 24.6545 1.81666C25.1152 2.2773 25.1152 3.02415 24.6545 3.48479L10.8773 18.1833C10.656 18.4046 10.356 18.5288 10.0432 18.5288C9.73035 18.5288 9.43033 18.4046 9.20912 18.1833L1.34548 10.3197C0.884839 9.85906 0.884839 9.11221 1.34548 8.65157Z"
        fill="#ADEEE2"
        stroke="#ADEEE2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default GreenTickSVG;
